"use client";

import { useEffect, useRef, type ReactNode } from "react";
import { HYDRATION_READY_EVENT } from "@/lib/deferred-interactions";

/** Replay a queued button click only once this subtree has event handlers. */
export function HydrationReady({ children }: { children: ReactNode }) {
  const scope = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const element = scope.current;
    if (!element) return;
    element.removeAttribute("data-hydration-pending");
    element.dispatchEvent(new Event(HYDRATION_READY_EVENT, { bubbles: true }));
  }, []);
  return <div ref={scope} data-hydration-pending="" style={{ display: "contents" }}>{children}</div>;
}
